import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../common/html/element'

export const ShowOnChartBtn = ({
  activeRowGroupId,
  rowId,
  changeActiveRow,
}) => {
  const dispatch = useDispatch()

  const onClick = (rowId) => () => {
    dispatch(changeActiveRow(rowId))
  }

  return (
    <Element
      elementName="span"
      className="cursorPointer"
      style={{
        color: activeRowGroupId === rowId ? '#9C9C9C' : '#2C73E8',
      }}
      onClick={onClick(rowId)}
    >
      <Translate value="companyAnalysis.industryAnalysis.SHOW_ON_CHART" />
    </Element>
  )
}

ShowOnChartBtn.propTypes = {
  activeRowGroupId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  rowId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
}
